import { useEffect } from "react";

/** Keeps keyboard focus inside the mobile contact drawer and restores its opener. */
export function useChatDrawerFocus(ref, active, onClose) {
  useEffect(() => {
    if (!active || !ref.current) return;
    const panel = ref.current;
    const previous = document.activeElement;
    [...panel.querySelectorAll('input,button:not([disabled])')]
      .find((node) => node.getClientRects().length > 0)?.focus();
    function onKey(event) {
      if (event.key === "Escape") { event.preventDefault(); onClose(); return; }
      if (event.key !== "Tab") return;
      const targets = [...panel.querySelectorAll('input,button:not([disabled])')]
        .filter((node) => node.getClientRects().length > 0);
      const first = targets[0];
      const last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    panel.addEventListener("keydown", onKey);
    return () => { panel.removeEventListener("keydown", onKey); previous?.focus(); };
  }, [ref, active, onClose]);
}
